import { StyleSheet } from 'react-native'
import { formScreen } from "../../Styles/formScreen";

export default StyleSheet.create({
  ...formScreen,
})
  